export enum EPresent {
  BoardGame = 'board-game',
  SmartWatch = 'smart-watch',
  Socks = 'socks',
  Videogame = 'videogame',
  Book = 'book',
  VRGlasses = 'vr-glasses',
  Perfume = 'perfume'
}

export const presents = [
  EPresent.BoardGame,
  EPresent.SmartWatch,
  EPresent.Socks,
  EPresent.Videogame,
  EPresent.Book,
  EPresent.VRGlasses,
  EPresent.Perfume
]
